export default "__VITE_ASSET__BT2L4qv1__"